import React from "react";
import { IconCircleFilledIcon } from "../../../widget/common/ui/Icon";
import { useDispatch } from "react-redux";
import { appplyActionDocument } from "../../../libraries/state_reducers/service/FileDocumentPickerReducer";
import { removeModal } from "../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../const/ModalKeys";

const FileDocumentPickerButtons = () => {
  const dispatch = useDispatch();

  const applyDocumentDetail = () => {
    dispatch(appplyActionDocument(true));
    dispatch(removeModal(ModalKeys.file_document_viewer));
  };

  return (
    <div className="w-100 d-flex align-items-center justify-content-end">
      <IconCircleFilledIcon
        size={50}
        name="paper_plane"
        color="white"
        bgColor="bgcolor-primary"
        handleClick={() => applyDocumentDetail()}
      />
    </div>
  );
};

export default FileDocumentPickerButtons;
